module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/481fbac64b59203d7ddffa564a7537d8.svg";